import React, { useState } from "react";
import { Nav, Navbar, NavDropdown } from "react-bootstrap";
import { NavLink } from "react-router-dom";
import useAuth from "./../../hook/useAuth";
const NavBar2 = () => {
  const { user, logout } = useAuth();
  const [show, setShow] = useState(false)
  const showDropdown = () => {
    setShow(!show)
  }
  const hideDropdown = () => {
    setShow(false)
  }
  return (
    <div>
      <Navbar fixed="top" expand="lg">
        <div className="container-fluid mb-5">
          <Navbar.Toggle aria-controls="basic-navbar-nav" />
          <Navbar.Collapse id="basic-navbar-nav">
            <Nav className="" style={{marginRight:"0px"}}>
              <NavLink
                style={{
                  color: "black",
                  textDecoration: "none",
                  margin: "8px 5px",
                }}
                to="/"
              >
                HOME
              </NavLink>
              <NavLink
                style={{
                  color: "black",
                  textDecoration: "none",
                  margin: "8px 5px",
                }}
                to="/shop"
              >
                SHOP
              </NavLink>
              
               {/* dropdown */}
               <NavDropdown
                className="navDesign1"
                id="basic-nav-dropdown"
                title={
                  <span style={{
                    color: "black",
                    textDecoration: "none",
                    marginTop: "10px 5px",
                  }}>PAGES</span>
                }
                show={show}
                onMouseEnter={showDropdown}
                onMouseLeave={hideDropdown}
              >
                <NavDropdown.Item to="/about">
                  <NavLink
                    className=""
                    style={{
                      color: "black",
                      textDecoration: "none",
                      margin: "10px",
                    }}
                    to="/about"
                  >
                    About Us
                  </NavLink>
                </NavDropdown.Item>
                <NavDropdown.Item to="/contact">
                  <NavLink
                    className=""
                    style={{
                      color: "black",
                      textDecoration: "none",
                      margin: "10px",
                    }}
                    to="/contact"
                  >
                    Contact Us
                  </NavLink>
                </NavDropdown.Item>
                <NavDropdown.Item to="/alldatabase">
                  <NavLink
                    className=""
                    style={{
                      color: "black",
                      textDecoration: "none",
                      margin: "10px",
                    }}
                    to="/alldatabase"
                  >
                    Portfolio
                  </NavLink>
                </NavDropdown.Item>
                <NavDropdown.Item to="/alldatabase">
                  <NavLink
                    className=""
                    style={{
                      color: "black",
                      textDecoration: "none",
                      margin: "10px",
                    }}
                    to="/alldatabase"
                  >
                    What we do
                  </NavLink>
                </NavDropdown.Item>
                <NavDropdown.Item to="/alldatabase">
                  <NavLink
                    className=""
                    style={{
                      color: "black",
                      textDecoration: "none",
                      margin: "10px",
                    }}
                    to="/alldatabase"
                  >
                    Our Team
                  </NavLink>
                </NavDropdown.Item>
                <NavDropdown.Item to="/alldatabase">
                  <NavLink
                    className=""
                    style={{
                      color: "black",
                      textDecoration: "none",
                      margin: "10px",
                    }}
                    to="/alldatabase"
                  >
                    Our Process
                  </NavLink>
                </NavDropdown.Item>
                <NavDropdown.Item to="/alldatabase">
                  <NavLink
                    className=""
                    style={{
                      color: "black",
                      textDecoration: "none",
                      margin: "10px",
                    }}
                    to="/alldatabase"
                  >
                    Pricing Plans
                  </NavLink>
                </NavDropdown.Item>
               
                <NavDropdown.Item to="/alldatabase">
                  <NavLink
                    className=""
                    style={{
                      color: "black",
                      textDecoration: "none",
                      margin: "10px",
                    }}
                    to="/alldatabase"
                  >
                   404 Error Page
                  </NavLink>
                </NavDropdown.Item>
               
              </NavDropdown>

              {/* dropdown */}
              
             
            </Nav>
            <Nav className="mx-auto">
                <Navbar.Brand href="/" className="mx-auto">
                  <img src="/logo1.svg" style={{ height: "40px" }} alt="" />
                </Navbar.Brand>
              </Nav>
            <Nav>
              <NavLink
                style={{ color: "black", marginRight: "20px" }}
                to="/login"
              >
                <i className="far fa-user"></i>
              </NavLink>
              <NavLink style={{ color: "black", marginRight: "20px" }} to="/">
                <i className="far fa-heart"></i>
              </NavLink>
              <NavLink style={{ color: "black", marginRight: "20px" }} to="/">
                <i className="fab fa-opencart"></i>
              </NavLink>
              {user.email && (
                <NavLink
                  onClick={logout}
                  style={{ color: "black", marginRight: "20px" }}
                  to="/"
                >
                  <i className="fas fa-sign-out-alt"></i>
                </NavLink>
              )}
            </Nav>
          </Navbar.Collapse>
        </div>
      </Navbar>
    </div>
  );
};

export default NavBar2;
